import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=7e2cffde&scoped=true&"
import script from "./PageDetail.vue?vue&type=script&lang=js&"
export * from "./PageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2cffde",
  null
  
)

export default component.exports